import { useEffect, useState } from 'react';

export const useHasOverflow = (ref) => {
    const [vertical, setVertical] = useState(false);
    const [horizontal, setHorizontal] = useState(false);
    useEffect(() => {
        const current = ref.current || {};
        const { scrollWidth = 0, scrollHeight = 0, clientWidth = 0, clientHeight = 0 } = current;

        setVertical(scrollHeight > clientHeight);
        setHorizontal(scrollWidth > clientWidth);
    }, [ref, setHorizontal, setVertical]);

    return { hasHorizontalOverflow: horizontal, hasVerticalOverflow: vertical };
};
